import { useSelector } from "react-redux";

import type { PurchaseConfirmationReduxState } from "@app/modules/purchase-confirmation/store/configure-store";
import type { CheckoutReduxState } from "@app/types/checkout-redux-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

type ReduxState =
  | ResultsReduxState
  | CheckoutReduxState
  | PurchaseConfirmationReduxState;

export const useIsAuthenticated = () => {
  return useSelector<ReduxState, boolean>(state => !!state.user);
};
